import React, { useEffect } from 'react';
import { Box, Text, Group, ThemeIcon, Stack } from '@mantine/core';
import { IconPlaylistAdd } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface CreateTodoProps {
    onClose?: () => void;
    setInputValue?: (value: string) => void;
}

const CreateTodo: React.FC<CreateTodoProps> = ({ onClose }) => {
    const { t } = useTranslation(['ai']);
    
    return (
        <Box 
            p="md" 
            style={{ 
                maxWidth: '100%',
                display: 'flex',
                height: '494px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
            }}
        >
            <Stack align="center" gap="sm" style={{ textAlign: 'center' }}>
                <Group mb="sm">
                    <ThemeIcon 
                        variant="light" 
                        radius="xl" 
                        size={22} 
                        style={{ 
                            backgroundColor: '#E7F5FF',
                            padding: '2px'
                        }}
                    >
                        <IconPlaylistAdd size={20} color="#212529" />
                    </ThemeIcon>
                    <Text fw={600}>{t('features.createTodo.title')}</Text>
                </Group>
                
                <div style={{ marginBottom: '-10px' }}>
                    <Text size="sm" color="dimmed" style={{ textAlign: 'center' }}>
                        {t('features.createTodo.instruction1')}
                    </Text>
                </div>
                <div style={{ marginTop: '-5px' }}>
                    <Text size="sm" color="dimmed" style={{ textAlign: 'center' }}>
                        {t('features.createTodo.instruction2')}
                    </Text>
                </div>
                <Text size="sm" color="dimmed" style={{ textAlign: 'center' }}>
                    {t('features.createTodo.example')}
                </Text>
            </Stack>
        </Box>
    );
};

export default CreateTodo;
